import dayjs from "dayjs";

export const formatDate = (timestamp, showMs = false) => {
  const date = new Date(timestamp);
  const formattedDate = date.toLocaleString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
  const milliseconds = String(date.getMilliseconds()).padStart(3, "0");
  const result = showMs ? `${formattedDate}.${milliseconds}` : formattedDate;
  return result;
};

export const dashboardFormatDate = (date) => {
  return (
    new Date(date).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    }) +
    " | " +
    new Date(date).toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })
  );
};

export const disabled7DaysDate = (current) => {
  if (!current) return false;

  const today = dayjs();
  const sevenDaysAgo = today.subtract(6, "days");
  return current.isAfter(today, "day") || current.isBefore(sevenDaysAgo, "day");
};

export const formatTimestamp = (timestamp) => {
  if (!timestamp) {
    return "-";
  }
  return dayjs(Number(timestamp)).format("DD/MM/YYYY, HH:mm:ss.SSS");
};
